import React from "react";

function Lavagna() {
  var link =
    process.env.REACT_APP_LAVAGNA_LINK +
    "?auth_token=" +
    localStorage.getItem("authToken");
  return (
    <iframe
      src={link}
      style={{
        width: "100%",
        height: "100vh",
        border: "none",
        position: "absolute",
        top: 0,
        right: 0,
      }}
    />
  );
}

export default Lavagna;
